import styled from "styled-components";

export const AppContainer = styled.div`
  background: ${(props) => props?.bgColor ?? "#fff"};
  background-repeat: ${(props) => props?.bgRepeat ?? "no-repeat"};
  //background-position-y: center;
  background-size: ${(props) => props?.bgSize ?? "100vh"};
  min-height: calc(100vh) !important;
  margin-left: auto;
  margin-right: auto;
`;
